export enum LocalStorageKeys {
    THEME = 'theme',
    LEFT_NAVIGATION_DRAWER = 'LEFT_NAVIGATION_DRAWER',
    CORRECT_PRICE_FIELD_CATEGORY_USE_ALERT_OPEN = 'CORRECT_PRICE_FIELD_CATEGORY_USE_ALERT_OPEN',
    ORG_ID = 'ORG_ID'
}